import { render } from "./LMTable.vue?vue&type=template&id=5a0a91d3&ts=true"
import script from "./LMTable.vue?vue&type=script&lang=ts"
export * from "./LMTable.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__